export default "__VITE_ASSET__C$pew0qd__"